import io from 'socket.io-client';

import { auth } from './credentials';
import { BASE_URL } from 'consts';

export const createSocket = (namespace, params) =>
  io(`${BASE_URL}/${namespace}`, {
    transports: ['websocket'],
    auth: { token: auth().token },
    query: params,
  });
